import { useEffect } from 'react';
// import { useAllFieldsBaseQuery } from 'queries/fields';
import { useAccountMetaQuery } from '..';
import { useAccountConfigQuery, useAccountDataQuery } from '../account';
// import { useResourceManagementConfigQuery } from '../resource-management-configuration';
// import { useTimesheetConfiguration } from '../timesheets/configuration';

declare global {
  interface Window {
    destroyWorker?: () => void;
  }
}

const useInitData = () => {
  const { isLoading: isMetaLoading } = useAccountMetaQuery();

  const { isLoading: isAccountsLoading } = useAccountDataQuery();
  const { isLoading: isAccountConfigLoading } = useAccountConfigQuery();

  // const { isLoading: isAllFieldsLoading } = useAllFieldsBaseQuery();

  // const { isLoading: isResourceManagementConfigLoading } =
  //   useResourceManagementConfigQuery();

  // const { isLoading: isTaskFieldsLoading } = useTaskFieldsQuery();

  // const { isLoading: isMembersQueryLoading } = useMembersQuery();

  // const { isLoading: isMembersV2Loading } = useMembersV2Query({});

  // const { isLoading: isTimeSheetConfigurationLoading } =
  //   useTimesheetConfiguration();

  useEffect(() => {
    const isEverythingLoaded = Boolean(
      isAccountsLoading === false &&
        isMetaLoading === false &&
        // isAllFieldsLoading === false &&
        // isTaskFieldsLoading === false &&
        // isTimeSheetConfigurationLoading === false &&
        // isResourceManagementConfigLoading === false &&
        isAccountConfigLoading === false,
    );

    if (isEverythingLoaded && window.destroyWorker) {
      window.destroyWorker();
    }
  }, [
    isAccountsLoading,
    isMetaLoading,
    // isAllFieldsLoading,
    // isTaskFieldsLoading,
    // isTimeSheetConfigurationLoading,
    // isResourceManagementConfigLoading,
    isAccountConfigLoading,
  ]);

  return Boolean(
    isAccountsLoading && isMetaLoading,
    // && isAllFieldsLoading
  );
};

export { useInitData };
